<template>
  <div>
    <div :class="$style.switchWrapper">
      <h5 :class="$style.title">
        Enter your measurements
        <font-awesome-icon icon="question-circle" v-tooltip="tooltip"/>
      </h5>
      <SwitchCm />
    </div>

    <form @submit.prevent @submit="submit1">
      <div :class="$style.content">
        <div :class="$style.inputWrap">
          <div :class="$style.inputWrapLabel">Chest</div>
          <input
            v-if="this.isCm"
            v-model="form.output1"
            @input="updateCanvasOutput"
            :class="$style.input"
            type="number"
            placeholder="Chest (cm)"
          />
          <input
            v-if="!this.isCm"
            v-model="form.output1"
            @input="updateCanvasOutput"
            :class="$style.input"
            type="number"
            placeholder="Chest (in)"
          />
        </div>


      </div>
      <Button type="submit" :class="$style.submit">Find my size</Button>
      <Button
        type="bordered"
        :class="$style.canvasButtonMobile"
        @click="$emit('setActiveModal', 'MobileCanvas1')"
        >Get Your Measurements</Button
      >
      <div v-if="output" :class="$style.output">
        Recommended Size: {{ output }}
      </div>
      <div v-if="prevValues" :class="$style.output">
        Your past measurements: Chest:
        <span :class="$style.green">{{ prevValues.output1 }}</span> , Waist:
        <span :class="$style.green">{{ prevValues.output2 }}</span> , Hips:
        <span :class="$style.green">{{ prevValues.output3 }}</span>
      </div>
    </form>

    <div :class="$style.footer">
      <div :class="$style.sizeChart" @click="$emit('setActiveModal', 'Chart')">
        <font-awesome-icon icon="ruler" size="lg" />
        Size Chart
      </div>

      <div :class="$style.userBtns">
        <div v-if="user" :class="$style.footerButton" @click="updateValues">
          Save Measurements
        </div>

        <div
          :class="$style.footerButton"
          @click="$emit('setActiveModal', 'LogIn')"
        >
          <font-awesome-icon icon="user-circle" />
          Profile
        </div>
        <div v-if="user" :class="$style.footerButton" @click="logout">
          Logout
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import SwitchCm from "@/components/lib/SwitchCm";
import Button from "@/components/lib/Button";

export default {
  computed: mapState(["user", "canvasOutput", "prevValues", "isCm"]),
  components: {
    SwitchCm,
    Button,
  },
  data() {
    return {
      form: {},
      output: null,
      tooltip: "Don't know your measurements? Click here to virtually obtain them"
    };
  },
  methods: {
    ...mapMutations(["setCanvasOutput", "setUser"]),

    updateCanvasOutput() {
      this.setCanvasOutput(this.form);
    },

    getSuggestedSize(tableId, inputBust, inputWaist, inputHips){
      var oTable = document.getElementById(tableId);
      //var colLength = oTable.cols.length;


      var rowLength = oTable.rows.length;
     
      var sizeList = [];
      for (var i = 1; i < rowLength; i++) {
        // sizeName = oTable.cols.item(1).cells;

        var sizeName = oTable.rows[i].cells[0].innerHTML;
        var bustMin;
        var bustMax;


        var bustRange = oTable.rows[i].cells[1].innerHTML;
        var split = bustRange.split("-");
        if (split.length === 1) {
          bustMin = Number(split[0]);
          bustMax = Number(bustMin);
        } else if (split.length === 2) {
          bustMin = Number(split[0]);
          bustMax = Number(split[1]);
        }


        var size = {
          sizeName: sizeName,
          bustMin: bustMin,
          bustMax: bustMax,

        };
        //var size = {sizeName: sizeName, b: bust, w: waist, h: hips};
        sizeList.push(size);
      }

      for (var i = 0; i < sizeList.length; i++) {
        var bustCounter = i;
        var sizeChartBustMax = sizeList[i].bustMax;
        console.log("inputBust: ", inputBust);
        console.log("sizeChartBustMax: ", sizeChartBustMax);
        if (inputBust <= sizeChartBustMax) {
          break;
        }
      }


      const sizeIndex = Math.max(bustCounter);
      const suggestedSize = sizeList[sizeIndex].sizeName;

      return suggestedSize;

    },


    submit1() {

      const tableId = "ChartNameByUser";
      const inputBust = Number(this.form.output1);

      var bust;

      const tableElement = document.getElementById(tableId);

      if(this.isCm === true && tableElement.className === 'vdr-in'){
        bust = inputBust/2.54;


      }   
      else if(this.isCm === false && tableElement.className === 'vdr-cm'){
        bust = inputBust*2.54;

      }

      else{
        bust = inputBust;


      }
      console.log("bust: ", bust);

      this.output = this.getSuggestedSize(tableId, bust);
        this.$gtag.event('submit-c', {
        'event_category': 'analysis',
        'event_label': 'submit-click',
        'value': 1
      })

    },
    logout() {
      localStorage.setItem(process.env.JWT_KEY, "");
      this.setUser(null);
      this.form = {};
    },

    updateValues() {
      var outputs = {
        email: this.user.email,
        output1: Number(this.form.output1),
        output2: Number(this.form.output2),

      };
      axios.post(process.env.VUE_APP_SERVER + "/update.php", outputs);
    },
  },
  mounted() {
    this.$emit("title", "Enter your measurements");
    this.form = this.canvasOutput;
  },
};
</script>



<style lang="scss" module>
$gray: #cccccd;
$dark: #262626;

.header {
  display: flex;
  justify-content: flex-start;
}

.canvasButton {
  cursor: pointer;
  color: $dark;
  transition: 0.2s;
  display: none;
  font-weight: bold;
  &:hover {
    color: $gray;
  }

  @media (min-width: 768px) {
    display: block;
  }
}

.content {
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
  }
}

.title {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 30px;
  font-weight: normal;
}

.input {
  display: inline-block;
  padding: 4px;
  margin: 10px 0;

  @media (min-width: 768px) {
    display: inline-block;
    width: 100%;
    margin: 10px 0;
  }
}

.canvasButtonMobile {
  outline-color: rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  @media (min-width: 768px) {
    display: none;
    outline-color: rgb(0, 0, 0);
    color: rgb(0, 0, 0);
  }
}

.green {
  color: green;
}

.footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin: 20px 16px;
  color: $dark;
  text-decoration: none;
  font-weight: bold;

  @media (min-width: 768px) {
    margin-bottom: 80px;
  }
}

.footerButton {
  cursor: pointer;
  color: $dark;
  transition: 0.2s;
  font-weight: bold;

  &:hover {
    color: $gray;
  }
}

.sizeChart {
  cursor: pointer;
  color: $dark;
  transition: 0.2s;
  font-weight: bold;

  &:hover {
    color: $gray;
  }
}

.vitruvianLink {
  display: flex;
  justify-content: center;
  font-size: small;
  cursor: pointer;
  color: rgb(111, 118, 124);
  margin-left: 20px;
  transition: 0.2s;
  &:hover {
    color: rgb(77, 77, 77);
  }
}

.vitruvianPrivacy {
  display: flex;
  justify-content: center;
  font-size: x-small;
  cursor: pointer;
  color: rgb(111, 118, 124);
  margin-left: 20px;
  transition: 0.2s;
  &:hover {
    color: rgb(77, 77, 77);
  }
}
.submit {
  display: block;
  width: 100%;
  border: 0;
  outline: 0;
  padding: 10px;
  background-color: rgb(0, 0, 0);
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
  margin-top: 20px;
  font-weight: bold;

  &:hover {
    background-color: rgb(34, 34, 34);
  }
}

.inputWrap {
  text-align: center;
  margin: 0 10px;
}

.inputWrapLabel {
  text-align: center;
  font-size: small;
}

.inputWrapText {
  text-align: center;
}

.links {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  a {
    color: $gray;
    text-decoration: none;
  }
}

.userBtns {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
</style>
